import { useMemo } from 'react';
import { useTheme } from '@material-ui/core/styles';

const useCircles = ({
  projects,
  selectedPosition,
  circleRadius
}) => {
  const theme = useTheme();
  // 🟢 Circle for selected position
  const selectedPositionCircle = useMemo(() => {
    if (!selectedPosition || !circleRadius) {
      return [];
    }

    return [
      {
        id: 'editable-circle',
        desc: `Valittu sijainti - säde ${circleRadius}m`,
        options: {
          strokeColor: theme.palette.primary.main,
          strokeOpacity: 0.6,
          strokeWeight: 2,
          fillColor: theme.palette.primary.main,
          fillOpacity: 0.3,
          clickable: false,
          draggable: false,
          editable: true,
          visible: true,
          radius: circleRadius,
          zIndex: 1,
        },
        center: {
          lat: Number(selectedPosition.latitude),
          lng: Number(selectedPosition.longitude),
        },
      },
    ];
  }, [ selectedPosition, circleRadius, theme.palette.success.main]);

  // 🔵 Circles for projects that require proximity
  const projectCircles = useMemo(() => {
    if (!projects) return [];

    return projects
      .filter(
        (p) =>
          p.proximityToClockInRequired === true &&
          p.latitude &&
          p.proximityToClockInRadius
      )
      .map((p) => ({
        id: p.id,
        desc: `${p.projectKey} - ${p.name}`,
        options: {
          strokeColor: theme.palette.primary.main,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: theme.palette.primary.main,
          fillOpacity: 0.4,
          clickable: false,
          draggable: false,
          editable: false,
          visible: true,
          radius: p.proximityToClockInRadius || 0,
          zIndex: 1,
        },
        center: {
          lat: Number(p.latitude),
          lng: Number(p.longitude),
        },
      }));
  }, [projects, theme.palette.primary.main]);

  // ⚪ Combine all circles
  const allCircles = useMemo(() => {
    const combined = [...projectCircles, ...selectedPositionCircle];
    return combined;
  }, [projectCircles, selectedPositionCircle]);

  return { selectedPositionCircle, projectCircles, allCircles };
};

export default useCircles;
